export const templateLabelPlacements = {
  Default: 'default',
  LeftOfField: 'leftOfField',
}

export const fieldLabelPlacements = {
  BasedOnForm: 'formSetting',
  Default: 'default',
  LeftOfField: 'leftOfField',
}
